<script setup lang="ts">
import { useQueryClient } from "@tanstack/vue-query";

import { queries } from "~/queries";
import { InputAutocomplete } from "~/types/InputAutocomplete";

const { loaded, getName } = useLocalisedCountryName();

type Option = {
  value: string;
  label: string;
};

const countries = ref<Option[]>([]);
const queryClient = useQueryClient();

watchEffect(async () => {
  if (!loaded.value || countries.value.length > 0) return;

  const countriesResponse = await queryClient.fetchQuery({
    ...queries.countries.list(),
    staleTime: Infinity,
  });

  if (countriesResponse.results.length > 0) {
    countries.value = countriesResponse.results
      .map((country) => {
        let countryName = country.name;

        if (country.countryCode) {
          const localisedCountryName = getName(country.countryCode);

          if (localisedCountryName) {
            countryName = localisedCountryName;
          }
        }

        return {
          label: countryName ?? "Unknown",
          value: country.countryCode ?? "N/A",
        };
      })
      .filter((option) => option.value !== "N/A")
      .sort((a, b) => a.label.localeCompare(b.label));
  }
});
</script>

<template>
  <FormKit
    type="select"
    :autocomplete="InputAutocomplete.Country"
    validation="required"
    :label="$t('myAccount.verify.address.country')"
    :placeholder="`${$t('myAccount.verify.address.country')}*`"
    :options="countries"
    :floating-label="true"
  />
</template>
